(function () {
  const defaultI18n = {
    send: 'Submit',
    sending: 'Submitting…',
    success: 'Your question was received.',
    submitError: 'Your question could not be submitted. Please try again.',
    validationError: 'Please fill in all required fields.',
  };

  const parseI18n = (modal) => {
    const node = modal.querySelector('[data-question-submit-i18n]');
    if (!node) {
      return { ...defaultI18n };
    }
    try {
      return { ...defaultI18n, ...JSON.parse(node.textContent) };
    } catch (error) {
      return { ...defaultI18n };
    }
  };

  const resolveStoreShop = (form, modal) => {
    const shopInput = form ? form.querySelector('input[name="shop"]') : null;
    const datasetShop = modal ? modal.dataset.questionSubmitShop : '';
    const shop =
      typeof window.jokerStorefrontShop === 'function'
        ? window.jokerStorefrontShop(datasetShop)
        : '';
    if (shop && shopInput) {
      shopInput.value = shop;
    }
    return shop;
  };

  const buildSubmitUrl = (apiBase, shop) => {
    const base = apiBase.replace(/\/$/, '');
    return `${base}/api/storefront/submit-question?shop=${encodeURIComponent(shop)}`;
  };

  const getHoneypotValue = (formData) => {
    return String(formData.get('review_bot_check') || formData.get('website') || '').trim();
  };

  const openModal = (modal) => {
    if (!modal) {
      return;
    }
    bindModal(modal);
    modal.removeAttribute('hidden');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('review-submit-open');
    const focusTarget =
      modal.querySelector('.review-submit__login-btn') ||
      modal.querySelector('.review-submit__textarea');
    if (focusTarget) {
      focusTarget.focus();
    }
  };

  const closeModal = (modal) => {
    if (!modal) {
      return;
    }
    modal.setAttribute('hidden', '');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('review-submit-open');
    const feedback = modal.querySelector('[data-question-submit-feedback]');
    if (feedback) {
      feedback.hidden = true;
      feedback.textContent = '';
      feedback.classList.remove('is-success');
    }
  };

  const setFeedback = (modal, message, isSuccess) => {
    const feedback = modal.querySelector('[data-question-submit-feedback]');
    if (!feedback) {
      return;
    }
    feedback.textContent = message || '';
    feedback.classList.toggle('is-success', Boolean(isSuccess));
    feedback.hidden = !message;
    if (message) {
      feedback.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
  };

  const buildPayload = (form, modal) => {
    const shop = resolveStoreShop(form, modal);
    const formData = new FormData(form);
    const honeypot = getHoneypotValue(formData);
    if (honeypot) {
      return null;
    }

    const firstName = String(formData.get('firstName') || '').trim();
    const lastName = String(formData.get('lastName') || '').trim();
    const customerEmail = String(formData.get('authorEmail') || '').trim();
    const body = String(formData.get('body') || '').trim();
    const showAuthorName = formData.get('showAuthorName') === 'on';
    const productId = String(formData.get('productId') || modal.dataset.questionSubmitProductId || '').trim();
    const productTitle = String(formData.get('productTitle') || modal.dataset.questionSubmitProductTitle || '').trim();
    const customerId = String(modal.dataset.questionSubmitCustomerId || '').trim();

    if (!shop || !customerId || !customerEmail || !firstName || !lastName || !body || !productId || !productTitle) {
      return { invalid: true };
    }

    return {
      shop,
      customerId,
      customerEmail,
      firstName,
      lastName,
      showAuthorName,
      productId,
      productTitle,
      body,
    };
  };

  const submitForm = async (modal, form, i18n) => {
    const apiBase = modal.dataset.questionSubmitApi || '';
    const submitButton = form.querySelector('[data-question-submit-button]');
    const defaultLabel = i18n.send || submitButton?.textContent || '';
    const shop = resolveStoreShop(form, modal);
    const payload = buildPayload(form, modal);

    if (!payload) {
      setFeedback(modal, i18n.success, true);
      form.reset();
      return;
    }
    if (payload.invalid) {
      setFeedback(modal, i18n.validationError, false);
      return;
    }

    if (!shop || !apiBase) {
      setFeedback(modal, i18n.submitError, false);
      return;
    }

    if (submitButton) {
      submitButton.disabled = true;
      submitButton.textContent = i18n.sending || defaultLabel;
    }

    try {
      const response = await fetch(buildSubmitUrl(apiBase, shop), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) {
        throw new Error(data.error || i18n.submitError);
      }
      setFeedback(modal, data.message || i18n.success || '', true);
      form.reset();
    } catch (error) {
      setFeedback(modal, error.message || i18n.submitError || '', false);
    } finally {
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.textContent = defaultLabel;
      }
    }
  };

  const bindModal = (modal) => {
    if (modal.dataset.questionSubmitBound === 'true') {
      return;
    }

    const form = modal.querySelector('[data-question-submit-form]');
    const i18n = parseI18n(modal);

    modal.querySelectorAll('[data-question-submit-close]').forEach((el) => {
      el.addEventListener('click', () => {
        closeModal(modal);
      });
    });

    if (form) {
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        submitForm(modal, form, i18n);
      });
    }

    modal.dataset.questionSubmitBound = 'true';
  };

  const bindOpenTriggers = () => {
    document.querySelectorAll('[data-question-submit-open]').forEach((trigger) => {
      if (trigger.dataset.questionSubmitOpenBound === 'true') {
        return;
      }
      trigger.addEventListener('click', () => {
        const modal = document.getElementById(trigger.dataset.questionSubmitOpen || '');
        openModal(modal);
      });
      trigger.dataset.questionSubmitOpenBound = 'true';
    });
  };

  const init = () => {
    document.querySelectorAll('[data-question-submit-modal]').forEach(bindModal);
    bindOpenTriggers();
  };

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') {
      return;
    }
    const openModalEl = document.querySelector('[data-question-submit-modal]:not([hidden])');
    if (openModalEl) {
      closeModal(openModalEl);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
